import ReceiptLongOutlined from "@mui/icons-material/ReceiptLongOutlined";
import VideocamOffOutlined from "@mui/icons-material/VideocamOffOutlined";
import Alert from "@mui/material/Alert";
import Badge from "@mui/material/Badge";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import CircularProgress from "@mui/material/CircularProgress";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { QrScanner } from "@yudiel/react-qr-scanner";
import { useState } from "react";
import DarkModeOutlined from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlined from "@mui/icons-material/LightModeOutlined";
import IconButton from "@mui/material/IconButton";
import { useTheme } from "@mui/material/styles";
import { ActiveOrdersModal } from "~/components/active-orders-modal";
import { useGetCurrentDevice } from "~/queries/use-get-current-device";
import { useToggleColorMode } from "~/providers/app-provider";

export function Home() {
	const [cameraError, setCameraError] = useState<any>();
	const [errorMessage, setErrorMessage] = useState("");
	const [qrContent, setQrContent] = useState("");
	const [showActiveOrders, setShowActiveOrders] = useState(false);
	const { data: device } = useGetCurrentDevice();
	const toggleColorMode = useToggleColorMode();
	const {
		palette: { mode },
	} = useTheme();

	const toggleActiveOrders = () => {
		setShowActiveOrders((bool) => !bool);
	};

	return (
		<Container
			maxWidth={false}
			sx={{
				width: "100vw",
				height: "100vh",
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				alignItems: "center",
				gap: 2,
				position: "relative",
			}}>
			<Stack
				direction="row"
				alignItems="center"
				gap={1}
				sx={{
					position: "absolute",
					zIndex: 20,
					top: { xs: 16, sm: 24 },
					right: { xs: 16, sm: 24 },
				}}>
				<IconButton onClick={toggleActiveOrders}>
					<Badge
						badgeContent={device?._active_orders?.length ?? 0}
						color="primary">
						<ReceiptLongOutlined />
					</Badge>
				</IconButton>
				<IconButton onClick={toggleColorMode}>
					{mode === "light" ? <DarkModeOutlined /> : <LightModeOutlined />}
				</IconButton>
			</Stack>

			{showActiveOrders && <ActiveOrdersModal onClose={toggleActiveOrders} />}

			{cameraError ? (
				<Stack sx={{ gap: 2, justifyContent: "center", alignItems: "center" }}>
					<VideocamOffOutlined fontSize="large" />
					Couldnt start camera: &nbsp;
					{typeof cameraError === "string"
						? cameraError
						: cameraError?.message || "Unknown error"}
				</Stack>
			) : (
				<>
					<Box textAlign="center">
						<Typography
							variant="body1"
							fontWeight="bold">
							Scan QR
						</Typography>
						<Typography variant="body2">Point this at Served QR</Typography>
					</Box>

					<Box sx={{ width: 350 }}>
						<QrScanner
							constraints={{
								facingMode: "environment",
								width: { min: 640, ideal: 720, max: 1920 },
								height: { min: 640, ideal: 720, max: 1080 },
							}}
							scanDelay={1000}
							onResult={(result) => {
								if (!result) return;

								const qrTextContent = result.getText();
								const isServedQr = qrTextContent.startsWith(
									process.env.SHORTEN_URL!,
								);
								if (!isServedQr) {
									setErrorMessage("Not a valid Served QR. Try again.");
									return;
								}

								setErrorMessage("");
								setQrContent(qrTextContent);

								window.location.replace(qrTextContent);
							}}
							onError={setCameraError}
						/>
					</Box>
				</>
			)}

			{!!errorMessage && <Alert severity="error">{errorMessage}</Alert>}
			{!!qrContent && (
				<Alert
					icon={<CircularProgress size="24px" />}
					severity="warning">
					Taking you to the menu... &nbsp;
				</Alert>
			)}

			<Stack
				direction="row"
				sx={{
					position: "fixed",
					bottom: 0,
					gap: 2,
					alignItems: "center",
					justifyContent: "center",
				}}>
				<img
					src="/images/favicon.png"
					width="50px"
				/>

				<Chip
					label={[process.env.VERSION, process.env.ENV]
						.filter(Boolean)
						.join("-")}
					color="primary"
				/>
			</Stack>
		</Container>
	);
}
